"use client"
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import theme from "src/components/themes/DefaultTheme";
import { gql } from "graphql-request";
import { useFilminfo } from "src/lib/client/useFilminfo";
import styled from 'src/lib/styles/css';
import IPremiumLandingPage from "src/lib/types/IPremiumLandingPage";
import useElementInView from "src/lib/client/useElementInView";


//#region [Props]
type PromotedVideoProps = {
    landingpage: IPremiumLandingPage;
};
//#endregion

//#region [Component]
export default function PromotedVideo({ landingpage }: PromotedVideoProps) {
    const { fiLoading, fiData } = useFilminfo(QUERY, { clipId: landingpage.promotedVideoId }, { active: (landingpage.promotedVideoId ?? 0) > 0 })

    const { ref, isInView } = useElementInView<HTMLDivElement>({ triggerOnce: true });

    if ((landingpage.promotedVideoId ?? 0) <= 0) {
        return null;
    }
    return <SPromotedVideo ref={ref}>
        {fiLoading && <LoadingIndicator position="InlineCenter" />}
        {!fiLoading &&
            isInView &&
            fiData?.movieQuery?.getMovieClipEmbedCode &&
            <div dangerouslySetInnerHTML={{ __html: fiData?.movieQuery?.getMovieClipEmbedCode }}></div>}
    </SPromotedVideo>


}
//#endregion

//#region [Other]
const QUERY = gql`
query ($clipId: Int, $playerId: Int) {
	movieQuery {
		getMovieClipEmbedCode(clipId: $clipId, playerId: $playerId)
	}
}
`;
//#endregion

//#region [Styles]
const SPromotedVideo = styled.div`
	margin: 20px auto 0 auto;
	padding-bottom: 40px;
	@media (min-width: 550px) {
		margin: 50px auto 0 auto;
		padding-bottom: 100px;
	}
`;
//#endregion